import React from "react";
import { Container, Message } from 'semantic-ui-react'

import Header from "../ui/Header";
import Footer from "../ui/Footer";

import { translate } from "../../addons/Translate";

const ThanksPage = (props) => {
	return (
		<div id="ThanksPage">
			<Header />

			<Container textAlign="center">
				<Message positive>
				    <Message.Header>{translate('xxltable.thanks.head')}</Message.Header>
				    <p>{translate('xxltable.thanks.desc')}</p>
				</Message>
			</Container>

			<Footer />
		</div>
	);
}

export default ThanksPage;


// WEBPACK FOOTER //
// ./src/components/pages/ThanksPage.js